export const roleMeta = {
  owner: {
    title: 'Owners',
    description:
      'Invoiced for trips. Owners can also schedule and fly on trips.',
  },
  manager: {
    title: 'Managers',
    description:
      'Can change the pilots on any trip and choose which owner a trip is billed to.',
  },
  pilot: {
    title: 'Pilots',
    description: 'Can be assigned to fly trips.',
  },
  flyer: {
    title: 'Flyers',
    description: 'Can schedule trips but are not invoiced.',
  },
  guest: {
    title: 'Guests',
    description:
      'Passengers who have been added to a trip. Cannot schedule trips.',
  },
}

export function roleLabel(type) {
  return type.charAt(0).toUpperCase() + type.slice(1)
}
